import React from 'react';

const ME = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
      fill="#D4AF2C"
    />
    <mask
      id="mask0_3_99"
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="19"
      height="13"
    >
      <path
        d="M19 1H2C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H19C19.5523 14 20 13.5523 20 13V2C20 1.44772 19.5523 1 19 1Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_99)">
      <path
        d="M19 1H2C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H19C19.5523 14 20 13.5523 20 13V2C20 1.44772 19.5523 1 19 1Z"
        fill="#C60000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 4.778L9.333 4L8.556 4.778H9.333L8.556 5.556L7 4.778V8.668L9.333 7.888L8.556 9.444H7.778L8.556 10.222L9.333 9.444L10.5 11V4.778ZM11.667 4L12.444 4.778H11.667L12.444 5.556L14 4.778V8.668L11.667 7.888L12.444 9.444H13.222L12.444 10.222L11.667 9.444L10.5 11V4.778L11.667 4Z"
        fill="#D5B02B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 6.505C9 5.675 9.666 5 10.5 5C11.328 5 12 5.673 12 6.505V6.162C12 6.992 11.492 8.118 10.88 8.664L10.5 9L10.12 8.664C9.503 8.114 9 6.994 9 6.162V6.505Z"
        fill="#185D93"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 6H12V7H9V6Z"
        fill="#C58724"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default ME;
